<template>
    <div v-if="getData">
        <h2 class="headerName">
            {{ headerName }}
        </h2>
        <p><strong>This request has been <span :class="procedureStatus === 'approved' ? 'approved' : 'disapproved'">{{ procedureStatus.toUpperCase() }}</span>.</strong></p>
        <section>
            <h2 class="headerName">
                Details
            </h2>
            <ul style="margin-bottom: 15px;">
                <li><strong>Patient:</strong> {{ patientName }} (Birthdate: {{ birthdate }}, Gender: {{ sex }})</li>
                <li><strong>Medical Provider:</strong> {{ data.HOSP_NAME }}</li>
                <li><strong>Requesting HMI-Accredited Doctor:</strong> {{ data.REQUEST.DOCTOR ? `DR. ${data.REQUEST.DOCTOR}` : 'Not Available' }}</li>
                <li><strong>Date Issued:</strong> {{ approveDate }}</li>
                <li v-if="procedureStatus === 'approved'">
                    <strong>Valid Until:</strong> {{ validDate }}
                </li>
                <li><strong>Contract Number:</strong> {{ contractNo }}</li>
                <li><strong>Reason/Chief Complaint:</strong> {{ data.CHIEF_c }}</li>
                <li><strong>Initial Diagnosis:</strong> {{ data.DIAG }}</li>
                <li><strong>Requested Diagnostic Procedure(s):</strong> {{ diaProList }}</li>
            </ul>
        </section>
        <template v-if="data.APPROVED">
            <h2 class="headerName">
                Approval
            </h2>
            <p>The out-patient procedure approval slip for {{ patientName }} has been generated.</p>
            <p><strong>Note:</strong> Please print two copies of the approval slip.</p>
            <PdfViewer
                v-if="pdfData"
                :pdf-data="pdfData"
            />
            <!-- <p>The member will also receive a copy via email ({{ data.EMAIL }}).</p> -->
        </template>
        <template v-else>
            <v-alert type="error">
                {{ data.REMA }}
            </v-alert>
            <v-alert dense outlined>
                <p class="errMsgNote">
                    <span style="font-weight: 600;">If you need to request for a repeat diagnostic procedure for patient monitoring or other purposes:</span>
                    <ul>
                        <li>Submit your request via email to <a style="font-weight: bold;" href="mailto:medical@hmi.com.ph">medical@hmi.com.ph</a>.</li>
                        <li>Provide the details shown above.</li>
                        <li>
                            Attach the following documents:
                            <ul>
                                <li>HMI Card of the Patient</li>
                                <li>Doctor's Request for Diagnostic Procedure</li>
                                <li>Other Relevant Supporting Documents of the Patient</li>
                            </ul>
                        </li>
                    </ul>
                </p>
            </v-alert>
        </template>
        <p><strong>Disclaimer:</strong> This approval for the referenced service or treatment is provisional. If further review determines the service/treatment isn't covered by the member's health plan, the patient may be responsible for any incurred costs.</p>
        <p class="hmiContact">
            <strong>For further inquiries:</strong> Please contact HMI directly at (02) 8811-1313, (02) 7752-0552, (02) 8865-3700, 0999-993-4895 and 0917-853-3705.
        </p>
    </div>
</template>

<script>
import { moment } from '../../../utils/date-shim'
import PdfViewer from './PdfViewer.vue'
export default {
    components: {
        PdfViewer
    },
    props: ['data'],
    data: ()=>({
        contractNo: null,
        validDate: null,
        approveDate: null,
        sex: null,
        birthdate: null,
        patientName: null,
        procedureStatus: null,
        headerName: null,
        procedureResult: null,
        pdfData: null,
        result: null,
        diaProList: ''
    }),
    computed: {
        getData() {
            if (this.data) this.fetchData(this.data)
            return true
        }
    },
    methods: {
        fetchPdf(pdf, fileName) {
            this.pdfData = pdf ? { url: pdf, type: 'application/pdf', fileName } : null
        },
        fetchData(data) {
            this.contractNo = `${data.MEMB_N}-${data.PROG_C}`
            this.validDate = moment(data.VALI_D).format('D MMMM YYYY')
            this.approveDate = moment(data.APPR_D).format('D MMMM YYYY')
            this.sex = data.SEX === 'F' ? 'FEMALE' : 'MALE'
            this.birthdate = moment(data.DOB).format('D MMMM YYYY')
            this.patientName = `${data.NAME}`
            this.procedureStatus = data.APPROVED ? 'approved' : 'disapproved'
            this.headerName = 'Out-Patient Procedure '
            data.APPROVED
                ? this.headerName += `Approved (OPPA No.: ${data.OPPAN_NO})`
                : this.headerName += 'Disapproved'
            const pdf = data && data.PDF ? data.PDF : null
            if (pdf) this.fetchPdf(pdf, `${data.MEMB_N}-${data.APPR_D}`)
            this.procedureResult = data

            if (data.DIAGNOSTICS && Array.isArray(data.DIAGNOSTICS)) {
                for (let i = 0; i < data.DIAGNOSTICS.length; i++) {
                    this.diaProList += String(data.DIAGNOSTICS[i].name).trim()
                    if (i + 1 < data.DIAGNOSTICS.length) {
                        this.diaProList += ', '
                    }
                }
            }
        }
    }
}
</script>

<style scoped>
.headerName {
    font-size: 20px;
}
.approved {
    color: #004d40;
}
.disapproved {
    color: rgb(133, 0, 0);
}
.hmiContact {
    margin-bottom: 40px;
}
.errMsgNote span {
    display: block;
}
    .errMsgNote ul li ul {
        font-weight: 600;
    }
    .errMsgNote ul li i {
        font-style: unset;
    }
</style>
